import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import { connect } from 'react-redux'
import { compose } from 'redux'
import _get from 'lodash/get'

import Link from '@components/Link'

import styles from './MobileNavbar.css'

export class MobileNavbar extends Component {
  render() {
    const { routes, configParams } = this.props
    const navbar = _get(configParams, 'quickAccess.navbar', [])
    const filteredNavbar = navbar.filter(res => res.enabled)
    return (
      <>
        <div className={styles.container__navbar}>
          {filteredNavbar.map(dt => (
            <Link key={dt.id} to={dt.path} className={styles.navbar__box}>
              <div
                className={
                  routes === dt.id
                    ? `${styles.navbar__img} ${styles[dt.active]}`
                    : `${styles.navbar__img} ${styles[dt.inactive]}`
                }
              />
              <p className={routes === dt.id ? styles.title__active : styles.title__inactive}> {dt.name} </p>
            </Link>
          ))}
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    configParams: { ...state.configParams },
  }
}

export default compose(withStyles(styles), connect(mapStateToProps))(MobileNavbar)
